import { createTheme } from '@material-ui/core/styles';
import { red } from '@material-ui/core/colors';

export function blurFilter(stdDeviation) {
  return `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' ><filter id='svgMask'><feGaussianBlur stdDeviation='${stdDeviation}' /></filter></svg>#svgMask")`;
}

const theme = createTheme({
  typography: {
    fontFamily: ['Muli', 'Muli-Bold'].join(','),
    h4: { fontSize: '1.9rem', fontFamily: 'Muli-Bold' },
    h3: { fontSize: 35 },
  },
  palette: {
    custom: {
      actions: '#C2CFE0',
      yellow: '#FFB946',
    },
    status: {
      complete: '#0d47a1',
      active: '#22bb33',
      scheduled: '#109CF1',
      draft: '#FFB946',
    },
    primary: {
      main: '#5453a6',
      light: '#9b9af3',
    },
    secondary: {
      main: '#6cc0ce',
    },
    info: {
      main: '#26BFF1',
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#fff',
    },
    lightBlack: '#4c4c4c',
  },
  fontSizes: { onboarding: 17 },
  blur: blurFilter,
  overrides: {
    MuiButton: {
      root: {
        textTransform: 'none',
      },
      containedPrimary: { color: 'white' },
    },
    MuiCheckbox: { colorPrimary: { color: '#5453a6' } },
  },
} as any);

export default theme;
